var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "newpassword-main",
    attrs: {
      "ma-0": "",
      "pa-3": "",
      "row": "",
      "justify-center": "",
      "align-start": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "newpassword-wrapper d-flex flex-column align-stretch",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg4": "",
      "xl3": "",
      "pa-3": ""
    }
  }, [_c('div', {
    staticClass: "newpassword-card"
  }, [_c('h1', {
    staticClass: "newpassword-title"
  }, [_vm._v("New Password")]), _c('p', {
    staticClass: "newpassword-description"
  }, [_vm._v("Please insert a new password.")]), _c('ValidationObserver', {
    ref: "observer",
    staticClass: "newpassword-form d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var invalid = _ref.invalid;
        return [_c('ValidationProvider', {
          attrs: {
            "rules": "required|min:20",
            "name": "Password",
            "vid": "password"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": "Password (20+ characters)",
                  "outlined": "",
                  "dense": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "append-icon": _vm.show_password ? 'mdi-eye' : 'mdi-eye-off',
                  "type": _vm.show_password ? 'text' : 'password'
                },
                on: {
                  "click:append": function ($event) {
                    _vm.show_password = !_vm.show_password;
                  }
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v;
                  },
                  expression: "password"
                }
              })];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "rules": "required|confirmed:password",
            "name": "Confirm password"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": "Confirm password",
                  "outlined": "",
                  "dense": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "append-icon": _vm.show_confirm_password ? 'mdi-eye' : 'mdi-eye-off',
                  "type": _vm.show_confirm_password ? 'text' : 'password'
                },
                on: {
                  "click:append": function ($event) {
                    _vm.show_confirm_password = !_vm.show_confirm_password;
                  }
                },
                model: {
                  value: _vm.confirmPassword,
                  callback: function ($$v) {
                    _vm.confirmPassword = $$v;
                  },
                  expression: "confirmPassword"
                }
              })];
            }
          }], null, true)
        }), _c('v-btn', {
          staticClass: "newpassword-btn",
          attrs: {
            "type": "submit",
            "loading": _vm.loading,
            "disabled": _vm.submitted && invalid || _vm.loading
          },
          on: {
            "click": function ($event) {
              return _vm.onNewPassword();
            }
          }
        }, [_vm._v("Submit")])];
      }
    }])
  }), _c('router-link', {
    staticClass: "newpassword-back-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_c('v-icon', {
    staticClass: "back-arrow",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to Login ")], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }